import { OdataManager } from '@/api/odata/odata-manager';
import { Notification } from '@/api/model/interfaces';

export default class NotificationOdata extends OdataManager<Notification> {}
